import { render, staticRenderFns } from "./Wordpress.vue?vue&type=template&id=248c1e02&scoped=true&"
import script from "./Wordpress.vue?vue&type=script&lang=js&"
export * from "./Wordpress.vue?vue&type=script&lang=js&"
import style0 from "./Wordpress.vue?vue&type=style&index=0&id=248c1e02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248c1e02",
  null
  
)

export default component.exports